import { ReactNode } from "react";
import {
  InfoIconHoverAlert,
  InfoIconHoverAlertProps,
} from "shared/components/InfoIconHoverAlert";
import { Flex, Separator, Switch, Text } from "shared/components/Spor";

type WithOrWithoutRushToggle =
  | {
      isRush?: never;
      toggleIsRush?: never;
    }
  | {
      isRush: boolean;
      toggleIsRush: () => void;
    };

type InfoHeaderProps = {
  title: string;
  headerContent?: ReactNode;
  tooltipWidth?: string | number;
} & InfoIconHoverAlertProps &
  WithOrWithoutRushToggle;

export const InfoHeader = ({
  title,
  isRush,
  toggleIsRush,
  headerContent,
  tooltipWidth,
  ...props
}: InfoHeaderProps) => (
  <Flex width="100%" alignItems="center" justifyContent="space-between">
    <Flex alignItems="center" gap="1.5">
      <Text variant="md" fontWeight="bold">
        {title}
      </Text>
      {toggleIsRush && isRush !== undefined && (
        <>
          <Separator orientation="vertical" height="5" />
          <Switch size="sm" checked={isRush} onCheckedChange={toggleIsRush} />
          <Text variant="sm">Vis behov under rush</Text>
        </>
      )}
    </Flex>

    <Flex alignItems="center" gap="1">
      {headerContent}
      <InfoIconHoverAlert width={tooltipWidth} {...props} />
    </Flex>
  </Flex>
);
